import { createContext } from "react";

export const AudioUrlsContext = createContext<
  { label: string | undefined; value: string }[]
>([]);
